import React, { Component } from 'react'
import Slider from "react-slick";
import './carousel.scss'
import classes from './Carousel.module.css'
import Avatar from '../../images/account-circle.svg'

export default class extends Component {
    render() {
        return (
            <div className={classes.CarouselContainer}>
                <div style={{maxWidth: 1170, padding: '20px 20px 40px', margin: 'auto'}}>
                    <SimpleSlider />
                </div>
            </div>


        );
    }
}

const AvatarImage = ({ alt }) => (
    <img src={Avatar} alt={alt} style={{with: 44, height: 34, marginRight: 6, marginBottom: 0}}/>
)

const TestimonialItem1 = () => (
    <div className={classes.TestimonialContainer}>
        <em>
            J’ai une bonne famille, mais ils ne sont pas toujours disponibles pour m’aider. J’ai pris contact avec le centre qui a tout de suite repérer mon problème et ma prise en charge a été immédiate. Cela fait depuis un moment qu’ils me suivent et ils ont toujours réponses à toutes mes questions.
        </em>
        <div className={classes.TestimonialUserContainer}>
            <AvatarImage alt="avis de Jennifer, Neuchâtel"/> Jennifer, Neuchâtel
        </div>
    </div>
)

const TestimonialItem2 = () => (
    <div className={classes.TestimonialContainer}>
        <em>
            Je suis très reconnaissant envers le Psy-scan Institute, car ils m’ont aidé à m’en sortir dans les moments les plus difficiles de ma vie. Aujourd’hui je suis en paix avec moi-même et j’ai une bonne relation avec mes proches.
        </em>
        <div className={classes.TestimonialUserContainer}>
            <AvatarImage alt="avis de Anonyme, La Chaux-de-Fonds"/> Anonyme, La Chaux-de-Fonds
        </div>
    </div>
)


const TestimonialItem3 = () => (
    <div className={classes.TestimonialContainer}>
        <em>
            Au début, j’avais peur du regard des gens sur moi, car je ne voulais pas donner l’impression d’être faible par rapport au faîte que je consultais un psychologue. Lorsque j’ai commencé à y aller, j’ai réalisé ma force en suivant des thérapies individuelles et cela m’a beaucoup aidé; j’encourage fortement toutes femmes qui ont vécu des traumatismes dans leur vie de prendre un rendez-vous et avoir un suivie thérapeutique.
        </em>
        <div className={classes.TestimonialUserContainer}>
            <AvatarImage alt="avis de Anonyme, Yverdon"/> Anonyme, Yverdon

        </div>
    </div>
)

const TestimonialItem4 = () => (
    <div className={classes.TestimonialContainer}>
        <em>
            En tant que parents, qui  à connu des moments difficiles avec un enfant qui souffrait de problèmes de santé mentale, le Psy-Scan Institute nous a été d’une grande aide. Leur personnel professionnel nous a fourni les mécanismes et le soutien qui nous a permis de comprendre et d’accepter ce que nous vivons. Ils nous ont aidés à développer les compétences et l’empathie nécessaires pour soutenir notre enfant. Toute ma famille apprécie tellement l’aide que nous avons reçue.
        </em>
        <div className={classes.TestimonialUserContainer}>
            <AvatarImage alt="avis de Marc"/> Marc
        </div>
    </div>
)

class SimpleSlider extends React.Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 7000,
            dotsClass: 'slick-dots'
        };
        return (
            <Slider {...settings}>
                <div><TestimonialItem1 /></div>
                <div><TestimonialItem2 /></div>
                <div><TestimonialItem3 /></div>
                <div><TestimonialItem4 /></div>
            </Slider>
        );
    }
}